<template>
    <section id="about" class="about container">
        <div class="wrapper">
            <div class="about-column-one">
                <img class="about__image-tablet" src="@/assets/img/about.jpg"
                srcset="@/assets/img/about@2x.jpg 2x,
                @/assets/img/about@3x.jpg 3x">
            </div>
            <div class="about-column-two">
                <h2 class="about__title">A bit <br><span class="underlined-text">about us<span class="underline"></span></span></h2>
                <img class="about__image" src="@/assets/img/about.jpg"
                srcset="@/assets/img/about@2x.jpg 2x,
                @/assets/img/about@3x.jpg 3x">
                <div class="about__text text" v-html="aboutText"></div>
                <a class="btn" href="#contact" @click.prevent="$emit('scroll', '#contact')">Work with us</a>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: ['aboutText']
}
</script>

<style lang="scss">
@import '@/assets/css/helpers-variables.scss';

.about {
    margin-bottom: 80px;
    & .wrapper {
        max-width: $phone-l;
        @media (min-width: $tablet) {
            max-width: $wrapper;
            display: flex;
        }
    }
    @media (min-width: $laptop-s) {
    margin-bottom: 120px;
  }
}
.about-column-one {
    display: none;
    text-align: right;
    @media (min-width: $tablet) {
        width: 50%;
        display: block;
    }
}
.about-column-two {
    @media (min-width: $tablet) {
        width: 50%;
    }
}
.about__title {
    font-size: 2.5em;
    font-weight: 600;
    line-height: 1.2;
    margin-bottom: 40px;
    @media (min-width: $laptop-s) {
    font-size: 4em;      
  }
  @media (min-width: $laptop-l) {
      font-size: 4.4em;
  }
}
.about__image {
    margin-bottom: 40px;
    width: 100%;
    @media (min-width: $tablet) {
        display: none;
    }
}
.about__image-tablet {
    // transform: scale(1.5);
}
.about__text {
    margin-bottom: 40px;
}
</style>
